/* DITTMANN shared state, shared countdown and shared media player.
   Idempotent: the file may be referenced by several sections on one page, so it
   must survive being executed more than once. */
window.DM = window.DM || (function () {
  'use strict';
  var KEY = 'dm_vehicle';
  var PARAM = 'dmv';
  var cache = null;

  function read() {
    if (cache) return cache;
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) { var o = JSON.parse(raw); if (o && o.make && o.model && o.year) { cache = o; return o; } }
    } catch (e) {}
    return null;
  }

  function write(v) {
    if (!v || !v.make || !v.model || !v.year) return null;
    cache = { make: String(v.make), model: String(v.model), year: String(v.year) };
    try { localStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('dm:vehicle', { detail: cache })); } catch (e) {}
    return cache;
  }

  function clear() {
    cache = null;
    try { localStorage.removeItem(KEY); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('dm:vehicle', { detail: null })); } catch (e) {}
  }

  function label(v) {
    v = v || read();
    return v ? (v.make + ' ' + v.model + ' (' + v.year + ')') : '';
  }

  /* Carry the vehicle across to the product page so the customer never types it twice. */
  function decorate(url, v) {
    v = v || read();
    if (!url || !v) return url || '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + PARAM + '=' + encodeURIComponent(v.make + '|' + v.model + '|' + v.year);
  }

  /* Adopt a vehicle handed over in the URL, then tidy the address bar. */
  (function adopt() {
    try {
      var p = new URLSearchParams(window.location.search);
      var raw = p.get(PARAM);
      if (!raw) return;
      var bits = raw.split('|');
      if (bits.length === 3 && bits[0] && bits[1] && bits[2]) {
        write({ make: bits[0], model: bits[1], year: bits[2] });
      }
      p.delete(PARAM);
      var qs = p.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}
  })();

  function euro(cents) {
    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function on(fn) {
    document.addEventListener('dm:vehicle', function (e) { fn(e.detail); });
  }

  /* ------------------------------------------------------------------
     COUNTDOWN — one engine for the whole site.

     The promo bar appears on every page, and every one of them runs this same
     function: there is no second copy anywhere.

     The clock belongs to the visitor, not to the page. On the first visit the
     moment it should reach zero is written to localStorage; every later page
     load reads that moment back, so refreshing or moving to another page picks
     the count up where it was rather than starting over. When it does reach
     zero a fresh full cycle is written and the count starts again — it never
     stops. Private browsing throws on localStorage; there the clock simply
     starts a full cycle on each load, which is the sensible fallback.

     The stored duration is kept alongside the deadline. If the merchant edits
     the duration in the theme editor, the old deadline is thrown away rather
     than leaving visitors on the previous cycle.
     ------------------------------------------------------------------ */
  var CD_KEY = 'dm_cd';

  function deadline(seconds) {
    var now = Date.now();
    var span = seconds * 1000;
    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(CD_KEY) || 'null'); } catch (e) {}
    if (stored && stored.dur === seconds && typeof stored.end === 'number' && stored.end > now) {
      return stored.end;
    }
    var end = now + span;
    try { localStorage.setItem(CD_KEY, JSON.stringify({ end: end, dur: seconds })); } catch (e) {}
    return end;
  }

  function countdown(el) {
    if (!el || el.getAttribute('data-dm-cd-on') === '1') return;
    el.setAttribute('data-dm-cd-on', '1');

    var seconds = parseInt(el.getAttribute('data-seconds'), 10);
    if (!seconds || seconds < 1) seconds = 16348;
    var uh = el.getAttribute('data-h') || 'Std.';
    var um = el.getAttribute('data-m') || 'Min.';
    var us = el.getAttribute('data-s') || 'Sek.';
    var slot = el.querySelector('[data-u="clock"]');
    if (!slot) return;

    var end = deadline(seconds);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    function part(value, unit) {
      return '<span class="dm-pr__n">' + value + '</span><span class="dm-pr__u">' + unit + '</span>';
    }

    function paint() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left < 0) {
        /* Straight into a new full cycle, with no gap and no "over" state. */
        end = Date.now() + seconds * 1000;
        try { localStorage.setItem(CD_KEY, JSON.stringify({ end: end, dur: seconds })); } catch (e) {}
        left = seconds;
      }
      var h = Math.floor(left / 3600);
      var m = Math.floor(left % 3600 / 60);
      var s = left % 60;
      slot.innerHTML = part(h, uh) + ' ' + part(pad(m), um) + ' ' + part(pad(s), us);
      el.hidden = false;
    }

    paint();
    setInterval(paint, 1000);
  }

  function scanCountdowns(scope) {
    var all = (scope || document).querySelectorAll('[data-dm-countdown]');
    for (var i = 0; i < all.length; i++) countdown(all[i]);
  }

  /* ------------------------------------------------------------------
     The one media player on this site. Every [data-dm-media] slot on every
     page goes through it — the autoplay blocks and the review carousels alike.
     There is no second implementation anywhere.

     Two modes, told apart by data-autoplay:

     CLICK TO PLAY (data-autoplay absent) — the review carousels:
       * preload="none" and NO source, so zero video bytes before the load event;
       * the source is attached and metadata warmed only once the card is on
         the screen; pointerenter / pointerdown / touchstart raise preload to "auto";
       * play() runs synchronously on click, with sound, never on its own;
       * one clip at a time, no loop, and it stops when it leaves the screen.

     AUTOPLAY (data-autoplay="1") — muted, looping, no controls.

       NOTHING EVER PAUSES THESE. No scroll, no touch, no pointer, no observer
       and no visibility change stops one. The file is written straight into
       the page by Liquid, with autoplay and preload="auto", exactly as
       Shopify's standard themes do it: the browser starts loading and playing
       each clip the moment it reads the tag, before any script has run — 480p
       on a phone, 720p on a wider screen. This script never gives these clips
       a source and never reloads one. It only reveals a clip once it plays,
       asks once more for every clip as soon as the page can be read, and, when
       the browser refuses, shows a small play button and retries on the next
       touch, tap or scroll. Reduced-motion settings do not stop them either.
     ------------------------------------------------------------------ */
  var current = null;

  function videoOf(card) { return card.querySelector('[data-role="video"]'); }
  function isAuto(card) { return card.getAttribute('data-autoplay') === '1'; }

  /* Shopify's Liquid video object hands a theme only TWO sources: the HLS
     manifest and the single largest MP4. The Files API shows that 720p and 480p
     MP4 renditions exist for every video in this shop — Liquid just does not
     surface them. Their URLs differ from the one Liquid gives by a single
     token, and Shopify's transcoding ladder is fixed per input tier, so the
     lower renditions can be addressed exactly. This table was read off all 50
     videos in the shop and every derived URL was checked to load. Nothing is
     re-encoded, renamed or re-uploaded: these files already exist, the theme
     merely asks for a different one of them.

     Heights are spelled out rather than parsed out of the token, so nothing
     depends on a regular expression surviving a round trip through the theme
     API. A token that is not in the table is left alone, and the URL Liquid
     gave always stays in the list as the following <source>. */
  var LADDER = {
    'HD-1080p-7.2Mbps': [['HD-720p-4.5Mbps', 720], ['SD-480p-1.5Mbps', 480]],
    'HD-1080p-3.3Mbps': [['HD-720p-2.1Mbps', 720], ['SD-480p-1.0Mbps', 480]],
    'HD-1080p-2.5Mbps': [['HD-720p-1.6Mbps', 720], ['SD-480p-0.9Mbps', 480]],
    'HD-720p-4.5Mbps': [['SD-480p-1.5Mbps', 480]],
    'HD-720p-3.0Mbps': [['SD-480p-1.2Mbps', 480]],
    'HD-720p-2.1Mbps': [['SD-480p-1.0Mbps', 480]],
    'HD-720p-1.6Mbps': [['SD-480p-0.9Mbps', 480]]
  };

  function renditions(o) {
    var out = [{ src: o.src, type: o.type, h: o.h || 0, orig: true }];
    for (var token in LADDER) {
      if (!LADDER.hasOwnProperty(token) || o.src.indexOf(token) === -1) continue;
      var lower = LADDER[token];
      for (var i = 0; i < lower.length; i++) {
        out.push({ src: o.src.split(token).join(lower[i][0]), type: o.type, h: lower[i][1] });
      }
      break;
    }
    return out;
  }

  /* Click-to-play slots only: the smallest MP4 that still covers the pixels
     the slot occupies, then the MP4 Liquid gave us, as a fallback. The HLS manifest is kept LAST,
     never first: Chrome and Firefox cannot play it at all, and a manifest in
     first position strands them on the poster. */
  function sourcesFor(card, list) {
    if (!list.length) return list;
    var hls = [], mp4 = [];
    for (var n = 0; n < list.length; n++) {
      var o = list[n];
      if (!o || !o.src) continue;
      if (/mp4/i.test(o.type || '')) { mp4 = mp4.concat(renditions(o)); } else { hls.push(o); }
    }
    if (!mp4.length) return list;
    var phone = window.innerWidth <= 749;
    var box = card.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var need = Math.round(Math.max(box.height || 0, 240) * dpr);
    if (phone) { need = Math.min(need, 720); }
    var sorted = mp4.slice().sort(function (a, b) { return (a.h || 0) - (b.h || 0); });
    var pick = null;
    for (var i = 0; i < sorted.length; i++) { if ((sorted[i].h || 0) >= need) { pick = sorted[i]; break; } }
    if (!pick) pick = sorted[sorted.length - 1];
    var out = [pick];
    for (var j = 0; j < mp4.length; j++) { if (mp4[j].orig && mp4[j].src !== pick.src) out.push(mp4[j]); }
    for (var k = 0; k < hls.length; k++) out.push(hls[k]);
    return out;
  }

  function attach(card, level) {
    var v = videoOf(card);
    if (!v) return null;
    /* An autoplay clip already has its sources in the page. Loading it again
       here would throw away what the browser has downloaded. */
    if (isAuto(card)) return v;
    if (v.getAttribute('data-loaded') !== '1') {
      var list = [];
      try { list = JSON.parse(card.getAttribute('data-srcs') || '[]'); } catch (e) {}
      list = sourcesFor(card, list);
      for (var i = 0; i < list.length; i++) {
        if (!list[i] || !list[i].src) continue;
        var el = document.createElement('source');
        el.src = list[i].src;
        if (list[i].type) el.type = list[i].type;
        v.appendChild(el);
      }
      /* Belt and braces: if every <source> fails — a rendition the CDN turns
         out not to have — go back to the URL Liquid gave and start over.
         Falling through the <source> list on its own proved too slow to rely
         on, so the swap is done here rather than left to the browser. */
      var back = null;
      for (var f = 0; f < list.length; f++) { if (list[f] && list[f].orig) { back = list[f].src; break; } }
      if (back && list[0] && !list[0].orig && !v.__dmFail) {
        v.__dmFail = 1;
        v.addEventListener('error', function onFail() {
          v.removeEventListener('error', onFail);
          v.__dmFail = 0;
          while (v.firstChild) v.removeChild(v.firstChild);
          v.src = back;
          try { v.load(); } catch (e) {}
        });
      }
      try { v.preload = level || 'metadata'; } catch (e) {}
      v.setAttribute('data-loaded', '1');
      try { v.load(); } catch (e) {}
      return v;
    }
    if (level === 'auto' && v.preload !== 'auto') {
      try { v.preload = 'auto'; } catch (e) {}
      if (v.readyState === 0) { try { v.load(); } catch (e) {} }
    }
    return v;
  }

  function stop(card) {
    if (!card) return;
    var v = videoOf(card);
    if (v) { try { v.pause(); } catch (e) {} try { v.currentTime = 0; } catch (e) {} }
    card.classList.remove('is-playing', 'is-buffering');
    card.setAttribute('aria-pressed', 'false');
  }

  function play(card) {
    var v = attach(card, 'auto');
    if (!v) return;
    if (current && current !== card) stop(current);
    current = card;
    v.muted = false;
    card.classList.add('is-playing');
    card.setAttribute('aria-pressed', 'true');
    if (v.readyState < 2) card.classList.add('is-buffering');
    var p = v.play();
    if (p && p.catch) p.catch(function () { stop(card); if (current === card) current = null; });
  }

  function wireCard(card) {
    if (card.getAttribute('data-dm-wired') === '1') return;
    card.setAttribute('data-dm-wired', '1');
    card.setAttribute('aria-pressed', 'false');
    card.addEventListener('click', function () {
      if (card.classList.contains('is-playing')) { stop(card); if (current === card) current = null; }
      else { play(card); }
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); card.click(); }
    });
    card.addEventListener('pointerenter', function () { attach(card, 'auto'); });
    card.addEventListener('pointerdown', function () { attach(card, 'auto'); });
    card.addEventListener('touchstart', function () { attach(card, 'auto'); }, { passive: true });
    var v = videoOf(card);
    if (v) {
      v.addEventListener('playing', function () { card.classList.remove('is-buffering'); });
      v.addEventListener('waiting', function () { if (card.classList.contains('is-playing')) card.classList.add('is-buffering'); });
      v.addEventListener('timeupdate', function () { if (v.currentTime > 0) card.classList.remove('is-buffering'); });
      v.addEventListener('ended', function () { stop(card); if (current === card) current = null; });
      v.addEventListener('pause', function () { card.classList.remove('is-playing', 'is-buffering'); card.setAttribute('aria-pressed', 'false'); });
    }
  }

  /* ---- autoplay slots ---- */
  var AUTO = [];
  var gestureWaiting = [];
  var gestureArmed = false;
  var LAST_ERR = {};

  function wireAuto(card) {
    if (card.getAttribute('data-dm-wired') === '1') return;
    card.setAttribute('data-dm-wired', '1');
    var v = videoOf(card);
    if (!v) return;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.addEventListener('error', function () { card.classList.remove('is-playing'); });
    /* The video only becomes visible over its still once it really plays. */
    v.addEventListener('playing', function () { card.classList.add('is-playing'); hideManualHint(card); });
    if (!v.paused && v.readyState > 2) card.classList.add('is-playing');
    posterFrom(card, v);
  }

  /* The still that already sits under the video doubles as its poster, at the
     URL the browser picked for it from the srcset, so it is never fetched a
     second time and the frame before the first picture is never black. */
  function posterFrom(card, v) {
    if (v.getAttribute('poster')) return;
    var img = card.querySelector('img');
    if (!img) return;
    var set = function () { if (img.currentSrc && !v.getAttribute('poster')) v.setAttribute('poster', img.currentSrc); };
    if (img.complete && img.currentSrc) { set(); } else { img.addEventListener('load', set, { once: true }); }
  }

  /* A browser that refuses the autoplay leaves the poster up. Rather than a
     dead frame, put a small play affordance on it and let a tap start the
     clip. Styling is inline so no stylesheet has to change for it. */
  function showManualHint(card) {
    if (card.querySelector('[data-dm-hint]')) return;
    var b = document.createElement('span');
    b.setAttribute('data-dm-hint', '1');
    b.setAttribute('aria-hidden', 'true');
    b.style.cssText = 'position:absolute;left:50%;top:50%;width:32px;height:32px;margin:-16px 0 0 -16px;' +
      'display:flex;align-items:center;justify-content:center;border-radius:50%;' +
      'background:rgba(255,255,255,.28);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);color:#fff;pointer-events:none;z-index:2';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" style="display:block;width:15px;height:15px;margin-left:2px"><path d="M8 5.5v13l10-6.5z"/></svg>';
    card.appendChild(b);
    card.style.cursor = 'pointer';
    if (!card.__dmHintClick) {
      card.__dmHintClick = function () {
        if (!card.querySelector('[data-dm-hint]')) return;
        hideManualHint(card);
        card.setAttribute('data-dm-user', '1');
        card.removeAttribute('data-dm-refused');
        requestPlay(card, true);
      };
      card.addEventListener('click', card.__dmHintClick);
    }
  }

  function hideManualHint(card) {
    var h = card.querySelector('[data-dm-hint]');
    if (h) h.remove();
    card.style.cursor = '';
  }

  /* Refused clips are tried again on the visitor's next tap or scroll — many
     in-app browsers allow playback once the page has been touched. A tap always
     retries; a scroll retries at most once every 1.5 seconds, so a browser that
     keeps refusing is not asked again on every scroll frame. */
  var lastRetry = 0;
  function retryBlocked() {
    var list = gestureWaiting.slice();
    gestureWaiting.length = 0;
    list.forEach(function (c) {
      c.removeAttribute('data-dm-refused');
      requestPlay(c);
    });
  }

  function armGesture() {
    if (gestureArmed) return;
    gestureArmed = true;
    var taps = ['pointerdown', 'touchstart', 'touchend', 'click', 'keydown'];
    var done = function () {
      taps.forEach(function (n) { document.removeEventListener(n, onTap, true); });
      window.removeEventListener('scroll', onScroll, true);
      gestureArmed = false;
      lastRetry = Date.now();
      retryBlocked();
    };
    var onTap = function () { done(); };
    var onScroll = function () { if (Date.now() - lastRetry >= 1500) done(); };
    taps.forEach(function (n) { document.addEventListener(n, onTap, { capture: true, passive: true }); });
    window.addEventListener('scroll', onScroll, { capture: true, passive: true });
  }

  function refused(card, err) {
    card.classList.remove('is-playing');
    card.setAttribute('data-dm-refused', '1');
    LAST_ERR[AUTO.indexOf(card)] = (err && err.name) + ': ' + (err && err.message);
    if (gestureWaiting.indexOf(card) === -1) gestureWaiting.push(card);
    armGesture();
    showManualHint(card);
  }

  /* One play() request at a time per video. A pause() of ours landing while a
     request is still settling rejects it with AbortError: that is not the
     browser refusing, so it never raises the button. */
  function requestPlay(card, force) {
    if (!force && card.getAttribute('data-dm-refused') === '1') return;
    var v = videoOf(card);
    if (!v) return;
    if (!v.paused) { hideManualHint(card); return; }
    if (v.getAttribute('data-dm-pending') === '1') return;
    v.muted = true;
    v.setAttribute('data-dm-pending', '1');
    var p;
    try { p = v.play(); } catch (e) { v.setAttribute('data-dm-pending', '0'); refused(card, e); return; }
    if (p && p.then) {
      p.then(function () {
        v.setAttribute('data-dm-pending', '0');
        card.removeAttribute('data-dm-refused');
        card.classList.add('is-playing');
        hideManualHint(card);
      }).catch(function (err) {
        v.setAttribute('data-dm-pending', '0');
        if (err && err.name === 'AbortError') return;
        refused(card, err);
      });
    } else {
      v.setAttribute('data-dm-pending', '0');
      card.classList.add('is-playing');
    }
  }

  /* Page-wide listener, installed once: coming back through the back/forward
     cache, every clip is asked to play again. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    AUTO.forEach(function (c) { requestPlay(c); });
  });

  function scan(scope) {
    var all = (scope || document).querySelectorAll('[data-dm-media]');
    var manual = [], auto = [];
    for (var i = 0; i < all.length; i++) {
      if (isAuto(all[i])) { wireAuto(all[i]); auto.push(all[i]); if (AUTO.indexOf(all[i]) === -1) AUTO.push(all[i]); }
      else if (all[i].hasAttribute('data-srcs')) { wireCard(all[i]); manual.push(all[i]); }
    }
    /* Every autoplay clip is asked at once, wherever it sits on the page. */
    for (var k = 0; k < auto.length; k++) requestPlay(auto[k]);

    if (!manual.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.intersectionRatio === 0 && current === e.target) { stop(e.target); current = null; } });
    }, { threshold: [0] });
    for (var j = 0; j < manual.length; j++) io.observe(manual[j]);
    var warmed = false;
    var warm = function () {
      if (warmed) return; warmed = true;
      var ip = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) { attach(e.target, 'metadata'); ip.unobserve(e.target); } });
      }, { rootMargin: '0px', threshold: 0.5 });
      for (var m = 0; m < manual.length; m++) ip.observe(manual[m]);
    };
    var go = function () {
      if (window.requestIdleCallback) { requestIdleCallback(warm, { timeout: 3000 }); }
      setTimeout(warm, 2500);
    };
    if (document.readyState === 'complete') { go(); } else { window.addEventListener('load', go, { once: true }); }
  }

  function boot(scope) {
    scanCountdowns(scope);
    scan(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  return { get: read, set: write, clear: clear, label: label, decorate: decorate, euro: euro, on: on,
           scanMedia: scan, scanCountdowns: scanCountdowns,
           stopMedia: function () { if (current) { stop(current); current = null; } },
           playAuto: requestPlay, autoSlots: AUTO, playErrors: LAST_ERR,
           KEY: KEY, PARAM: PARAM, CD_KEY: CD_KEY };
})();